module.exports = __webpack_public_path__ + "img/support-icon.2b5d29ac.png";